@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.title-container {
  margin-bottom: @space-32;
}

.title-and-step-container {
  display: flex;
  justify-content: space-between;
  gap: @space-16;
  @media screen and (max-width: 1000px) {
    flex-direction: column-reverse;
    gap: @space-8;
  }
}

.setup-title {
  font-weight: 600;
}

.step-number {
  min-width: 42px;
  color: var(--grey-600);
}
